import { LoaderCircle } from 'lucide-react';
import { cx } from '../../lib/cx';

export function Spinner({ className, label }: { className?: string; label?: string }) {
  return (
    <LoaderCircle
      className={cx('animate-spin motion-reduce:animate-none', className ?? 'h-[18px] w-[18px]')}
      strokeWidth={2}
      aria-hidden={label === undefined}
      aria-label={label}
      role={label === undefined ? undefined : 'img'}
    />
  );
}
